import { CommodityDetail } from "features/contracts/enums/commodityDetail";
import { TFunction } from "i18next";
import { getMeasuredDataType } from "features/shared/components/measuredData/measuredDataHelper";

export const getGraphDataTypeTranslation = (
  t: TFunction,
  commodityDetail: CommodityDetail,
  type: "title" | "label",
  toLower: boolean = false,
  isProduction: boolean = false
): string => {
  let tanslationKey = getMeasuredDataType(commodityDetail, isProduction);
  let result = t(`measuredDataGraphCard.${tanslationKey}.${type}`);

  return toLower ? result.toLocaleLowerCase() : result;
};



export const getGraphLabel = (
  t: TFunction,
  commodityDetail: CommodityDetail,
  dataType: "real" | "plan",
  isProduction: boolean = false,
  hasPlanData?: boolean
) => {
  let translation = getGraphDataTypeTranslation(t, commodityDetail, "label", false, isProduction);
  let dataTypeTrans = t(`measuredDataGraphCard.${dataType}`);

  if (hasPlanData) {
    return `${dataTypeTrans} ${translation.toLocaleLowerCase()}`;
  } else {
    return translation;
  }
};
